import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const buttonGroupVariants = cva("flex gap-3", {
  variants: {
    layout: {
      stack: "flex-col items-start",
      row: "flex-row items-center justify-center",
    },
  },
  defaultVariants: {
    layout: "stack",
  },
});

export interface ButtonGroupProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof buttonGroupVariants> {}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ className, layout, children, ...props }, ref) => {
    return (
      <div className={cn(buttonGroupVariants({ layout, className }))} ref={ref} {...props}>
        {children}
      </div>
    );
  },
);
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup, buttonGroupVariants };
